import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { SubscriptionStatus } from '../../../core/models/subscription/subscription-status.model';
import { SubscriptionStatusService } from '../../../core/services/subscription-status.service';

@Component({
    selector: 'app-trial-banner',
    standalone: true,
    imports: [CommonModule, RouterModule],
    template: `
        <ng-container *ngIf="status$ | async as status">
            <div
                *ngIf="status.isTrial && status.hasAccess"
                class="trial-banner"
                [class.trial-banner--urgent]="status.daysRemaining <= 3"
            >
                <span class="trial-banner__text">
                    <i class="pi pi-clock"></i>
                    <ng-container *ngIf="status.daysRemaining > 0; else lastDay">
                        Your free trial ends in <strong>{{ status.daysRemaining }}</strong>
                        {{ status.daysRemaining === 1 ? 'day' : 'days' }}.
                    </ng-container>
                    <ng-template #lastDay>Your free trial ends today.</ng-template>
                </span>
                <a routerLink="/billing" class="trial-banner__cta">Subscribe now</a>
            </div>
        </ng-container>
    `,
    styles: `
        .trial-banner {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 1rem;
            flex-wrap: wrap;
            padding: 0.625rem 1rem;
            margin-bottom: 1rem;
            border-radius: 8px;
            background: #eff6ff;
            border: 1px solid #bfdbfe;
            color: #1e3a8a;
            font-size: 0.875rem;
        }
        .trial-banner--urgent {
            background: #fef2f2;
            border-color: #fecaca;
            color: #991b1b;
        }
        .trial-banner__text {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
        }
        .trial-banner__cta {
            font-weight: 600;
            text-decoration: none;
            padding: 0.35rem 0.9rem;
            border-radius: 6px;
            background: currentColor;
            color: #fff !important;
        }
        .trial-banner--urgent .trial-banner__cta {
            background: #b91c1c;
        }
        .trial-banner:not(.trial-banner--urgent) .trial-banner__cta {
            background: #1d4ed8;
        }
    `
})
export class TrialBannerComponent {
    status$: Observable<SubscriptionStatus | null>;

    constructor(private readonly subscriptionStatusService: SubscriptionStatusService) {
        this.status$ = this.subscriptionStatusService.status$;
    }
}
